import type { TGrupoParcelas } from '@/utils/calculadora-valores-totais/processador-valores-decimal'
import type { TGrupoParcelasToUTC } from '@/utils/grupo-parcelas.utils'

export class EntradasMapper {
  static transform(grupo: TGrupoParcelas): TGrupoParcelasToUTC[] {
    if (!grupo?.length) return []
    return grupo.flatMap(({ valor, data }) => (data ? [{ parcelas: [{ data, valor }] }] : []))
  }
}
